import { defineStore } from 'pinia'
import type { ApplicationUser } from 'keycloak-js'

export type UserStoreReturnType = ReturnType<typeof useAuthStore>

export type UserStore = {
  user: ApplicationUser | null
  accessToken: string | null
  refreshToken: string | null
  roles: string[]
  errorMsg: string
  expiresIn: number
}

export const useAuthStore = defineStore('auth', {
  state: (): UserStore => ({
    user: null,
    accessToken: '',
    refreshToken: '',
    roles: [],
    errorMsg: '',
    expiresIn: 0,
  }),
  getters: {
    isLoggedIn(): boolean {
      return !!this.accessToken
    },
  },
  actions: {
    addRole(role: string): void {
      this.roles.push(role)
    },
    changeUserName(fullName: string) {
      if (this.user) {
        this.user.firstName = fullName.split(' ')[0]
        this.user.lastName = fullName.split(' ')[1]
      }
    },
  },
  persist: true,
})
